import actions from '../constants';

const initialState = {
  isOpen: true,
  selectedSection: 'benefits'
};

const welcome = function(state = initialState, action) {
  switch(action.type) {
    case actions.CLOSE_WELCOME:
      return {
        ...state,
        isOpen: false
      };
    case actions.CHANGE_SECTION:
      return {
        ...state,
        selectedSection: action.section
      };
    default:
      return state;
  }
};

export default welcome;



// WEBPACK FOOTER //
// ./src/advocate/onboarding/reducers/welcome.js